




















































































































































































































































































































































































































import { Component, Vue, Mixins, Watch } from "vue-property-decorator";
// 混入

import loading from "@/mixins/loading";
import {
  resetPayPassword,
  memberDetail,
  memberDeal,
  memberAndShop,
  memberList,
  updateVerifyStatus,
  memberUpdate,
  updateShopImage,
  rebateList,
  recommendList,
  updateDescription,
  getAccountRecommendInfo,
  updateSelfType,
} from "@/api/vip";
import { selectAllLabel } from "@/api/discount";
import copy from "@/utils/deepCopy";

@Component({
  components: {},
})
export default class Vip extends Mixins(loading) {
  userDetail: any = {};
  userDeal: any = {};
  userMoneny: any = {};
  keyName: string = "";
  imgUrl: string = "";
  dialogTitle: string = "";
  dialogVisibleImg: boolean = false;
  rebateListData0: Array<any> = [];
  rebateListData1: Array<any> = [];
  recommendListData0: Array<any> = [];
  recommendListData1: Array<any> = [];
  editableTabsValue: string = "1";
  userId: any = 0;
  dialogVisible: boolean = false;
  curEdit: string = "";
  userForm: any = {
    phone: "",
    remark: "",
    nickname: "",
    memberDiscountId: "",
  };
  identityOptions: any = [];

  dialogVisibleIdentity: boolean = false;

  selfType:number = 0;
  dialogVisibleSelfType:boolean = false;
  selfTypeOptions:any = [
    {
      label: '无',
      value: 0
    },
    {
      label: '直营门店',
      value: 1
    }
  ];

  @Watch("$route", { immediate: true })
  routechange(to: any, from: any) {
    this.editableTabsValue = "1";
    this.rebateListData0 = [];
    this.rebateListData1 = [];
    this.recommendListData0 = [];
    this.recommendListData1 = [];
    let { id } = to.query;
    if (!id) {
      this.$message.error("用户不存在");
      return;
    }
    this.userId = id;
    this.showLoading();
    this.getData(id);


  }

  viewVipInfo(userId: any) {
    let id = userId;
    this.$router.push({
      path: "/vipInfo",
      query: { id: id },
    });
  }

  getData(id: number) {
    memberAndShop({
      id: id,
    }).then((res: any) => {
      this.hideLoading();
      this.userDetail = res.data;
      let tempShopArr = [];
      let tempBusinessArr= [];

      let shopImage = this.userDetail.shopImage;
      tempShopArr = (shopImage && shopImage.split(",")) || [];

      tempShopArr = tempShopArr.map(
        (e: string) => ({
          name: e,
          url: this.$uploadImgUrl + e,
          originUrl: e,
        })
      );

      let businessLicense = this.userDetail.businessLicense;
      tempBusinessArr = (businessLicense && businessLicense.split(",")) || [];

      tempBusinessArr = tempBusinessArr.map(
        (e: string) => ({
          name: e,
          url: this.$uploadImgUrl + e,
          originUrl: e,
        })
      );
       this.userDetail.shopImageArr = tempShopArr;
       this.userDetail.businessLicenseArr = tempBusinessArr;
    });

    memberDeal({
      id: id,
    }).then((res: any) => {
      this.userDeal = res.data;
    });
  }

  getRebateList(status: number) {
    let userId = this.userId;
    if (!userId) {
      return;
    }
    rebateList({
      status: status,
      memberId: userId,
      pageNum: 1,
      pageSize: 9999,
    }).then((res: any) => {
      if (status == 0) {
        this.rebateListData0 = res.data.list;
      } else {
        this.rebateListData1 = res.data.list;
      }
    });
  }

  getRecommendList(status: number) {
    let userId = this.userId;
    if (!userId) {
      return;
    }
    recommendList({
      status: status,
      memberId: userId,
      pageNum: 1,
      pageSize: 9999,
    }).then((res: any) => {
      if (status == 0) {
        this.recommendListData0 = res.data.list;
      } else {
        this.recommendListData1 = res.data.list;
      }
    });
  }

  vipTabClick(val: any) {
    let { name } = val;
    switch (name) {
      case "1":
        this.getRebateList(1);
        break;
      case "2":
        this.getRebateList(0);
        break;
      case "3":
        this.getRecommendList(0);
        break;
      case "4":
        this.getRecommendList(1);
        break;
      default:
        break;
    }
  }

  userUpdate() {
    let temp: any = { id: this.userId };
    temp[this.curEdit] = this.userForm[this.curEdit];
    memberUpdate(temp).then((res: any) => {
      this.$message.success("修改成功");
      this.getData(this.userId);
      this.dialogVisible = false;
    });
  }

  // 修改用户类型
  modifyMemberType(row: any) {
    this.dialogVisibleIdentity = true;
    selectAllLabel().then((res: any) => {
      this.identityOptions = res.data;
    });
  }

  modifySelfType(){
    this.dialogVisibleSelfType = true;
  }

  confirmSelfType(){
    let temp:any = {
      id: this.userId,
      selfType: this.selfType
    }
    updateSelfType(temp).then((res:any)=>{
      this.$message.success("修改成功");
      this.getData(this.userId);
      this.dialogVisibleSelfType = false;
    })
  }

  // 确认身份
  confirmIdentity() {
    memberUpdate({
      id: this.userId,
      memberDiscountId: this.userForm.memberDiscountId,
    }).then((res: any) => {
      this.$message.success("修改成功");
      this.getData(this.userId);
    });
    this.dialogVisibleIdentity = false;
  }

  userEdit(type: string) {
    this.dialogVisible = true;
    this.curEdit = type;
  }

  resetForm() {
    this.dialogVisible = false;
    let reset: any = this.$refs["userForm"];
    reset.resetFields();
  }

  submitForm() {
    let reset: any = this.$refs["userForm"];

    reset.validate((valid: boolean) => {
      if (valid) {
        this.userUpdate();
      } else {
        return false;
      }
    });
  }

  resetPasswd() {
    let userDetail = this.userDetail;
    this.$confirm(
      `是否要重置该用户密码 ${userDetail.nickname}   ${userDetail.phone}? 重置后支付密码：123456`,
      "提示",
      {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }
    ).then(() => {
      resetPayPassword({
        id: userDetail.id,
      }).then((res: any) => {
        this.getData(this.userId);
        this.$message.success("重置成功");
      });
    });
  }

  viewOrderList() {
     let userDetail = this.userDetail;
    this.$router.push({
      path: "/order",
      query: { phone: userDetail.phone },
    });
  }

  // 在上架商品对话框：里删除商品图片
  handleRemove(file: any, fileList: any,keyName:any) {
    let upType = keyName;
    let tempShop = [];
    let tempBusiness= [];
    if (upType == "shopImage") {
      tempShop = copy(fileList);
    }

    if(upType == "businessLicense"){
      tempBusiness= copy(fileList);
    }

    updateShopImage({
      memberId: this.userDetail.id,
      [upType]: (upType == "shopImage" ?  tempShop
      .map((e: any) => {
          return e.originUrl;
      })
      .toString() : tempBusiness
      .map((e: any) => {
          return e.originUrl;
      })
      .toString()),
    }).then((res: any) => {
      this.$message.success('删除成功');
    });
  }
  // 在上架商品对话框：预览图片
  handlePictureCardPreview(file: any) {
    this.imgUrl = file.url;
    this.dialogVisibleImg = true;
  }
  // 在上架商品对话框：限制图片上传数量提示
  handleExceed() {
    this.$message.error("最多只能上传9张图片");
  }

  // 预览图片
  previewPic(url: string, title: string) {
    this.dialogTitle = title;
    this.imgUrl = url;
    this.dialogVisibleImg = true;
  }
  // 上传成功
  onSuccess(res: any, file: any) {
    let upType = this.keyName;
    let tempShop = copy(this.userDetail.shopImageArr);
    let tempBusiness= copy(this.userDetail.businessLicenseArr);

    if (upType == "shopImage") {
      tempShop.push({
        name: res.data.name,
        url: this.$uploadImgUrl + res.data.url,
        originUrl: res.data.url,
      });
    }

    if(upType == "businessLicense"){
     tempBusiness.push({
        name: res.data.name,
        url: this.$uploadImgUrl + res.data.url,
        originUrl: res.data.url,
      });
    }

    console.log(tempShop,tempBusiness)

    updateShopImage({
      memberId: this.userDetail.id,
      [upType]: (upType == "shopImage" ?  tempShop
      .map((e: any) => {
          return e.originUrl;
      })
      .toString() : tempBusiness
      .map((e: any) => {
          return e.originUrl;
      })
      .toString()),
    }).then((res: any) => {
      this.$message.success("上传成功");
    });
  }

  // 图片上传之前限制
  beforeAvatarUpload(file: any, key: string) {
    this.keyName = key;
    const isLt1M = file.size / 1024 / 1024 < 1;
    if (!isLt1M) {
      this.$message.error("上传头像图片大小不能超过 1MB!");
    }
    return isLt1M;
  }
}
